import React from 'react';
import { ChildrenType, DockType, WarningDialog } from '../../../index';
import DispatcherWindowManager from '../../../utility/window/WindowManager';

class Dialog extends WarningDialog {
  readonly queryId: string = `#${DispatcherWindowManager.DIALOG_CONTAINER_ID.dialog}`;
  protected multiWindow = true;
  enableToSetFocusToFirstField = false;
  props: any;
  renderChildren(windowObj?) {
    if (!this.multiWindow) {
      windowObj = this.state;
    }
    let children = this.props.children || windowObj.children || [];
    children = children.map((child: ChildrenType) => React.createElement(child.render, child.props));
    return React.Children.toArray(children);
  }

  renderMessage(windowObj) {
    if (!this.multiWindow) {
      windowObj = this.state;
    }
    let { text = null } = windowObj as any;
    return text ? <p className='dialog-info'>{text}</p> : null;
  }

  getChildren = (windowObj?, index?) => [this.renderMessage(windowObj), this.renderChildren(windowObj), this.renderToolbar(DockType.bottom, windowObj, index)] as any[];
}

export default Dialog;
